import { normalizeForSearch } from '@/utils/normalize-for-search'

export function filterByTextKey<T>(
  items: T[],
  getValue: (item: T) => string,
  searchValue?: string,
): T[] {
  const normalizedSearchValue = normalizeForSearch(searchValue || '')

  if (!normalizedSearchValue) {
    return items
  }

  return items.filter((item) =>
    normalizeForSearch(getValue(item)).includes(normalizedSearchValue),
  )
}
